import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.v3.cloudcom.com.br/',
})

export default api
